import { z } from 'zod';

/** The state of the Google Calendar connection, as the Calendar page shows it. */
export const googleCalendarStatusSchema = z.object({
  /** False when the server has no Google credentials: the button is not offered. */
  available: z.boolean(),
  connected: z.boolean(),
  /** The Google account the calendar comes from. */
  email: z.string().nullable(),
  /** Events and task blocks made here are copied to the Google primary calendar. */
  exportEvents: z.boolean(),
  lastSyncedAt: z.string().nullable(),
  /** The last sync problem in words, or null. "expired" asks to connect again. */
  lastError: z.string().nullable(),
  expired: z.boolean(),
});
export type GoogleCalendarStatus = z.infer<typeof googleCalendarStatusSchema>;

/** What one sync did. `more` is true when there is still work for the next round. */
export const googleCalendarSyncSchema = z.object({
  imported: z.number().int(),
  removed: z.number().int(),
  exported: z.number().int(),
  more: z.boolean(),
});
export type GoogleCalendarSync = z.infer<typeof googleCalendarSyncSchema>;

export const googleCalendarSettingsSchema = z.object({ exportEvents: z.boolean() });

/** Where Google sends the phone back when it connects the calendar: the app's Calendar page. */
export const NATIVE_CALENDAR_REDIRECT = 'dovefiniscono://calendario';

/** The page the phone opens in its browser to give access. */
export const googleCalendarPhoneStartSchema = z.object({ url: z.url() });

/** What the browser brought back to the app, which then proves who it is with its own session. */
export const googleCalendarPhoneFinishSchema = z.object({
  link: z.string().min(1).max(4096),
});
export type GoogleCalendarPhoneFinish = z.infer<typeof googleCalendarPhoneFinishSchema>;
